import styled from "@emotion/styled";

import { sizeToken } from "../ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";
import { theme } from "../ThemeProvider/CandyTheme/ThemeShorthand";

export const Body = styled.div({
    width: 800,
});

export const PrimaryValue = styled.div({
    marginBottom: sizeToken(1),
});

export const Caption = styled.span(props => ({
    fontSize: "16px",
    color: props.theme.candy.typography.primary.color,
    marginRight: sizeToken(1),
}));

export const Value = styled.span(props => ({
    fontFamily: theme(props).typography.fontFamily.monospace,
    fontSize: "14px",
}));

export const ValueGFV = styled.span(props => ({
    fontFamily: theme(props).typography.fontFamily.monospace,
    fontSize: "14px",
    cursor: "pointer",
}));

export const AllSettings = styled.pre(props => ({
    width: "100%",
    maxHeight: 300,
    overflow: "scroll",
    border: `1px solid ${props.theme.candy.border.color}`,
}));
